module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Matthew is an experienced teacher of history with a lifelong passion for the British monarchy. From childhood, he has been enthralled by the unique lives of our Kings and Queens. Amassing a vast body of knowledge on the subject, he is a writer for the Constitutional Monarchy Association and publishes academic articles in ‘The Crown’, a quarterly journal. When he is not teaching or writing, Matthew enjoys keeping up to date with the Royal Family and spending time with his much loved family (especially his godson and nephew – Luca).")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3.6753in",
      "height": "3.21139in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0